<template>
    <div>
        <el-form ref="formRef" :model="value" label-position="top" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item label="业务链名称" prop="bizName">
                        <el-input v-model="value.bizName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="业务链标识" prop="bizDefn">
                        <el-input v-model="value.bizDefn"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="DXPID" prop="bizDxpid">
                        <el-input v-model="value.bizDxpid"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="业务类型" prop="bizType">
                        <el-input v-model="value.bizType"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="业务链编码" prop="bizCharset">
                        <el-input v-model="value.bizCharset"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="业务链描述" prop="bizDesc">
                        <el-input v-model="value.bizDesc"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        value: Object,
    },
    components: {},
    data() {
        return {
            rules: {
                bizName: [{required: true, message: "这是必填字段", trigger: 'blur'}],
                bizDefn: [{required: true, message: "这是必填字段", trigger: 'blur'}],
                bizDxpid: [{required: true, message: "这是必填字段", trigger: 'blur'}],
                bizType: [{required: true, message: "这是必填字段", trigger: 'blur'}],
            },
        }
    },
    methods: {
        validate() {
            return this.$refs.formRef.validate();
        }
    }
}
</script>

<style scoped>

</style>